'use client';

import { useEffect, useState } from 'react';

/**
 * Defaults to `true` (online) so the client's first render matches the
 * static-export HTML — the real status only exists client-side
 * (`navigator.onLine`) and is applied after mount to avoid a hydration
 * mismatch / offline-banner flash.
 */
export function useOnlineStatus(): boolean {
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    setIsOnline(navigator.onLine);

    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
}
